"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
exports.__esModule = true;
exports.JavascriptExpressionEvaluator = void 0;
var node_1 = require("../node");
var functionsDefault_1 = require("./functionsDefault");
var array_1 = require("./node/array");
var binary_1 = require("./node/binary");
var call_1 = require("./node/call");
var compound_1 = require("./node/compound");
var conditional_1 = require("./node/conditional");
var identifier_1 = require("./node/identifier");
var literal_1 = require("./node/literal");
var member_1 = require("./node/member");
var sequence_1 = require("./node/sequence");
var this_1 = require("./node/this");
var unary_1 = require("./node/unary");
var parser_1 = require("./parser/parser");
var defaultEvaluators = (_a = {},
    _a[node_1.ExpressionNodeType.Array] = array_1.ArrayEvaluator,
    _a[node_1.ExpressionNodeType.Binary] = binary_1.BinaryEvaluator,
    _a[node_1.ExpressionNodeType.Call] = call_1.CallEvaluator,
    _a[node_1.ExpressionNodeType.Compound] = compound_1.CompoundEvaluator,
    _a[node_1.ExpressionNodeType.Conditional] = conditional_1.ConditionalEvaluator,
    _a[node_1.ExpressionNodeType.Identifier] = identifier_1.IdentifierEvaluator,
    _a[node_1.ExpressionNodeType.Literal] = literal_1.LiteralEvaluator,
    _a[node_1.ExpressionNodeType.Member] = member_1.MemberEvaluator,
    _a[node_1.ExpressionNodeType.Sequence] = sequence_1.SequenceEvaluator,
    _a[node_1.ExpressionNodeType.This] = this_1.ThisEvaluator,
    _a[node_1.ExpressionNodeType.Unary] = unary_1.UnaryEvaluator,
    _a);
var JavascriptExpressionEvaluator = (function () {
    function JavascriptExpressionEvaluator(functions, evaluators) {
        if (functions === void 0) { functions = []; }
        if (evaluators === void 0) { evaluators = {}; }
        this.evaluators = __assign(__assign({}, defaultEvaluators), evaluators);
        this.functions = __spreadArray(__spreadArray([], functionsDefault_1.functionsDefault, true), functions, true).reduce(function (functionsAcc, expressionFunction) {
            var _a;
            return (__assign(__assign({}, functionsAcc), (_a = {}, _a[expressionFunction.name] = expressionFunction, _a)));
        }, {});
    }
    JavascriptExpressionEvaluator.prototype.evaluate = function (expression, context) {
        var parser = new parser_1.JavascriptExpressionParser();
        return this.evaluateNode(parser.parse(expression), context || {});
    };
    JavascriptExpressionEvaluator.prototype.evaluateNode = function (expressionNode, context) {
        var type = expressionNode.type;
        var NodeEvaluator = this.evaluators[type];
        if (!NodeEvaluator) {
            throw new Error("Unsupported function type: ".concat(type));
        }
        return new NodeEvaluator(this, context).evaluate(expressionNode);
    };
    return JavascriptExpressionEvaluator;
}());
exports.JavascriptExpressionEvaluator = JavascriptExpressionEvaluator;
//# sourceMappingURL=evaluator.js.map